module.exports = __webpack_public_path__ + "static/media/2_cheese_cake_small.2285b8d3.jpg";